import { Flex, Image, Text } from "@chakra-ui/react";

const RETAILERS = [
  { src: "/pnp.jpg", alt: "Pick n Pay" },
  { src: "/chk.jpg", alt: "Checkers" },
  { src: "/dis.jpg", alt: "Dis-Chem" },
  { src: "/cli.jpg", alt: "Clicks" },
];

const RetailerTrustStrip = () => (
  <Flex direction="column" align="center" gap="14px">
    <Text
      fontSize="10px"
      fontWeight={700}
      letterSpacing="0.16em"
      textTransform="uppercase"
      color="rgba(15,22,38,0.5)"
    >
      Trusted with feeds from
    </Text>
    <Flex gap="24px" align="center" wrap="wrap" justify="center" opacity={0.85}>
      {RETAILERS.map((r) => (
        <Image
          key={r.alt}
          src={r.src}
          alt={r.alt}
          h="28px"
          borderRadius="4px"
          objectFit="contain"
        />
      ))}
    </Flex>
  </Flex>
);

export default RetailerTrustStrip;
